
































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getRealtimeConnection } from '@/utils/realtime'
import { HubConnection } from '@microsoft/signalr'
import { CancellationToken } from '@/utils/cancel'
import { TournamentAPI, TournamentState } from '@/api/tournament'
import userStore from '@/modules/auth/auth.store'
import { getModule } from 'vuex-module-decorators'

interface TournamentCheckInStartedResponse {
  tournamentId: string
  tournamentCheckInEndTime: number
  remainingMinutes: number
}

@Component
export default class InstantMatchSnackBar extends Vue {
  userModule = getModule(userStore, this.$store)
  longPollingTimer: NodeJS.Timer | undefined = undefined

  visible: boolean = false
  tournamentId: string = ''
  isWaitingForUserToCheckIn: boolean = false
  remainingMinutes: number = 0

  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  @Watch('hasLoggedIn')
  async updateVisibility() {
    if (!this.hasLoggedIn) {
      return
    }

    try {
      const res = await TournamentAPI.getMemberJoinedAutomatedTournament()
      this.visible = res.data.payload!.isJoined
      this.tournamentId = res.data.payload!.tournamentId
      this.isWaitingForUserToCheckIn = res.data.payload!.isWaitingForUserToCheckIn
      this.remainingMinutes = res.data.payload!.tournamentCheckInRemainingMinutes
    } catch (err) {
      // ignore error
      console.error(err)
      this.visible = false
    }
  }

  async created() {
    this.realtimeConnection = await getRealtimeConnection(
      this.realtimeConnectionCancellationToken
    )
    this.realtimeConnection.on(
      'tournamentCheckInStarted',
      this.onTournamentCheckInStarted
    )
    this.realtimeConnection.on(
      'joinedAutomatedTournamentStateUpdated',
      this.onJoinedAutomatedTournamentStateUpdated
    )

    this.longPollingTimer = setInterval(
      this.updateVisibility,
      (50 + Math.floor(Math.random() * 30)) * 1000
    )

    await this.updateVisibility()
  }

  beforeDestroy() {
    this.realtimeConnectionCancellationToken.cancel()
    if (this.realtimeConnection) {
      this.realtimeConnection.off(
        'tournamentCheckInStarted',
        this.onTournamentCheckInStarted
      )
      this.realtimeConnection.off(
        'joinedAutomatedTournamentStateUpdated',
        this.onJoinedAutomatedTournamentStateUpdated
      )
    }
    if (this.longPollingTimer) {
      clearInterval(this.longPollingTimer)
      this.longPollingTimer = undefined
    }
  }

  onTournamentCheckInStarted(payload: TournamentCheckInStartedResponse) {
    this.visible = true
    this.tournamentId = payload.tournamentId
    this.remainingMinutes = payload.remainingMinutes
    this.isWaitingForUserToCheckIn = true
  }

  async onJoinedAutomatedTournamentStateUpdated() {
    await this.updateVisibility()
  }

  navigateToTournament() {
    this.$router.push({
      name: 'InstantMatchDetails',
      params: {
        tournamentId: this.tournamentId
      }
    })
  }

  close() {
    this.visible = false
  }

  get text() {
    if (this.isWaitingForUserToCheckIn) {
      return this.$t('InstantMatchSnackBar.TournamentCheckInNow', [
        this.remainingMinutes
      ])
    }

    return this.$t('InstantMatchSnackBar.JoinedCurrently')
  }

  get hasLoggedIn() {
    return this.userModule.hasLoggedIn
  }

  get shouldShow() {
    if (
      this.$route.path.startsWith('/instant/') &&
      this.$route.params &&
      this.$route.params.tournamentId === this.tournamentId
    ) {
      return false
    }

    return !this.$route.path.startsWith('/match-games/')
  }
}
